<template>
  <Checkbox class="ts-checkbox" v-bind="$attrs" v-on="$listeners"><slot></slot></Checkbox>
</template>

<style lang="scss" scoped>
.ts-checkbox::v-deep {
  display: flex;
  align-items: center;

  .el-checkbox__input {
    .el-checkbox__inner {
      background: #ebecf0;
      background-image: linear-gradient(-42deg, #000000 0%, #ffffff 100%);
      background-blend-mode: soft-light, normal;
      background-clip: padding-box;
      border: 1px solid rgba(255, 255, 255, 0.32);
      box-shadow: inset -8px -8px 16px 0 #fafbff, inset 8px 8px 16px 0 #a6abbd, -2px -2px 6px 0 rgba(250, 251, 255, 0.8),
        2px 2px 6px 0 rgba(166, 171, 189, 0.48);
      border-radius: 4px;

      width: 16px;
      height: 16px;

      z-index: inherit;
    }
  }

  .el-checkbox__label {
    font-family: Roboto;
    font-size: 12px;
    color: #6d7587;
    font-weight: normal;
  }

  &.is-checked {
    .el-checkbox__input {
      .el-checkbox__inner {
        border-radius: 4px;
        box-shadow: inset 0 -4px 8px 0 rgba(235, 255, 247, 0.88), inset 0 4px 8px 0 rgba(24, 122, 92, 0.4),
          -2px -2px 6px 0 rgba(250, 251, 255, 0.8), 2px 2px 6px 0 rgba(166, 171, 189, 0.48);
        border: solid 1px rgba(235, 236, 240, 0.24);
        background-color: #99ffd1;

        &::after {
          left: 5px;
          top: 2px;
        }
      }
    }

    .el-checkbox__label {
      color: #242424;
    }
  }
}
</style>

<script>
import { Checkbox } from 'element-ui';

export default {
  name: 'TsCheckbox',
  components: {
    Checkbox
  }
};
</script>
